import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-pt-0 tw-p-10 tw-flex tw-flex-col" }
const _hoisted_2 = { class: "tw-text-[25px] tw-flex tw-flex-col tw-gap-[10px]" }
const _hoisted_3 = { class: "tw-font-semibold tw-text-[#211F58] tw-leading-[normal] tw-mb-[15px]" }
const _hoisted_4 = { class: "tw-text-[15px] tw-flex tw-flex-col tw-gap-[20px] tw-text-[#231F20]" }
const _hoisted_5 = { class: "tw-font-semibold" }
const _hoisted_6 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-10" }
const _hoisted_7 = { class: "tw-text-[13px] tw-font-medium tw-text-[#878787] tw-leading-[nomal]" }
const _hoisted_8 = { class: "tw-flex" }

import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import { ref, watch } from "vue";
import ModalComponent from "@/components/common/modalComponent.vue";
import CustomCheckBox from "@/components/common/customCheckBox.vue";
import { localStorageKey, styleClassContain } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'reorderYourActionModal',
  props: {
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  buttonText: {
    type: String as () => string | null,
    required: false,
    default: null,
  },
  show: {
    type: Boolean,
    required: true,
  },
},
  emits: ["update:show", "update:data"],
  setup(__props, { emit }) {

const props = __props;



let showRef = ref(props.show);
const isChecked = ref(false);

const updateIsChecked = () => {
  isChecked.value = !isChecked.value;
};

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);


const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const handleUpdateModal = () => {
  showRef.value = false;
  localStorage.setItem(
    localStorageKey.isDontShowModalReOrderAction,
    isChecked.value.toString(),
  );
  emit("update:data", showRef.value);
  emit("update:show", showRef.value);
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(ModalComponent, {
    "model-value": _unref(showRef),
    close: handleCloseModal,
    "max-width": 38,
    "style-class-contain": _unref(styleClassContain)
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        "is-header": `no__header`,
        style: {"z-index":"10"},
        title: "",
        onClose: handleCloseModal
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(__props.description) + " ", 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)(
                "app-assess-recommendations-modal-reorder-note-1",
              )), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "tw-flex tw-items-center tw-h-[20px] tw-cursor-pointer",
            onClick: updateIsChecked
          }, [
            _createVNode(CustomCheckBox, {
              class: _normalizeClass(`tw-h-[20px] !tw-mb-0 !tw-pl-[35px]`),
              size: "20px",
              "is-checked": isChecked.value,
              "onUpdate:isChecked": updateIsChecked
            }, null, 8, ["is-checked"]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(getComponentUiText)(
                "app-assess-recommendations-modal-reorder-button-title-checkbox-1",
              )), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_b_button, {
              style: {"line-height":"90%","border":"2px solid #387dff","height":"39px"},
              variant: "primary",
              class: "tw-w-fit tw-mr-[15px] tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
              type: "submit",
              onClick: handleCloseModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
              )), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_b_button, {
              style: {"line-height":"90%","height":"39px"},
              variant: "primary",
              class: _normalizeClass(`tw-w-fit tw-shadow-none ${`tw-bg-[#387DFF]`} tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]`),
              type: "submit",
              onClick: handleUpdateModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.buttonText ??
              _unref(getComponentUiText)(
                "app-settings-domain-verify-modal-delete-button-1",
              )), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "style-class-contain"]))
}
}

})